import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store, { persistor } from "./redux/store";
import { Provider } from "react-redux";
import { runSagas } from "./redux/sagas";
import { SendAnalytics, runAppSettingsSetup } from "./services/app.service";
import { PersistGate } from "redux-persist/integration/react";

runSagas();

// runAppSettingsSetup()

// useEffect(() => {
//   SendAnalytics()!;
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [window.location.pathname]);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(SendAnalytics()!);
